import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { ProductSeriesClusteredByFamily } from "../models/product-series-clustered-by-family";
import { PiaProductsService } from "../pia-api/pia-products.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

/**
 * used to get product series clustered by product family ID
 * @param route
 */
export const productSeriesResolver: ResolveFn<Observable<unknown | null>> =
  withLoading(
    (
      route: ActivatedRouteSnapshot,
    ): Observable<ProductSeriesClusteredByFamily | null> => {
      const piaProductsService = inject(PiaProductsService);

      const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

      const { countryID, languageID, year } = pathParamsHelper(route);

      if (!languageID || !countryID || isNaN(year)) {
        return of(null);
      }

      return piaProductsService
        .getProductSeriesByYearAndCountryAndLanguageClusteredByProductFamily(
          {
            countryID,
            languageID,
            year,
          },
          context,
        )
        .pipe(
          map((data) => {
            return data;
          }),
          catchError(() => {
            return of(null);
          }),
        );
    },
  );
